import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { AcceptAbsenceButtonProps } from '../../types'

export const getAcceptAbsenceButton = ({ t, openForm }: AcceptAbsenceButtonProps): Action => ({
  onClick: openForm,
  label: t('absenceRequest.buttons.accept'),
  testId: 'absence-request_action-accept',
  variant: 'contained',
  color: 'primary',
})
